import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Car, ChevronRight } from 'lucide-react';
import { vehiclesAPI, uploadsAPI } from '../services/api';
import { useT } from '../services/i18n';

const CarBrandsSection = () => {
  const { t } = useT();
  const [brands, setBrands] = useState(null);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    vehiclesAPI.getBrandPages().then((d) => {
      const all = d.brands || [];
      setTotal(all.length);
      const popular = all.filter((b) => b.popular).sort((a, b) => a.popular_order - b.popular_order);
      setBrands(popular.length ? popular : all.filter((b) => b.models_count > 0).sort((a, b) => b.models_count - a.models_count).slice(0, 10));
    }).catch(() => setBrands([]));
  }, []);

  if (!brands || brands.length === 0) return null;

  return (
    <section className="py-6 sm:py-10 bg-white border-t border-gray-100" data-testid="car-brands-section">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-end justify-between gap-4 mb-4 sm:mb-6">
          <h2 className="text-xl sm:text-2xl font-bold text-gray-900">{t('home.carBrands')}</h2>
          <Link to="/vehicules" className="hidden sm:inline-flex items-center gap-1 text-sm font-medium text-orange-600 hover:text-orange-700 whitespace-nowrap" data-testid="car-brands-all-link">{t('home.seeBrands', { n: total })} <ChevronRight size={16} /></Link>
        </div>

        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-10 gap-3 sm:gap-4">
          {brands.map((brand, i) => (
            <Link
              key={brand.name}
              to={`/vehicules/${brand.slug}`}
              title={t('home.partsFor', { brand: brand.name })}
              className="flex flex-col items-center p-3 sm:p-4 bg-gray-50 rounded-lg hover:bg-orange-50 hover:border-orange-200 border border-transparent transition-all group animate-in fade-in slide-in-from-bottom-2"
              style={{ animationDelay: `${i * 40}ms` }}
              data-testid={`car-brand-${brand.name}`}
            >
              <div className="w-14 h-14 bg-white rounded-full flex items-center justify-center shadow-sm mb-2 group-hover:shadow-md group-hover:scale-105 transition-all overflow-hidden">
                {brand.logo ? <img src={uploadsAPI.resolveUrl(brand.logo)} alt={brand.name} loading="lazy" className="w-10 h-10 object-contain" /> : <Car size={20} className="text-gray-400 group-hover:text-orange-600" />}
              </div>
              <span className="text-xs font-medium text-gray-700 text-center group-hover:text-orange-600 transition-colors leading-tight">{brand.name}</span>
              {brand.models_count > 0 && <span className="text-[10px] text-gray-400 mt-0.5 whitespace-nowrap">{t('home.models', { n: brand.models_count })}</span>}
            </Link>
          ))}
        </div>
        <Link to="/vehicules" className="sm:hidden mt-4 inline-flex items-center gap-1 text-sm font-medium text-orange-600" data-testid="car-brands-all-link-mobile">{t('home.seeBrands', { n: total })} <ChevronRight size={16} /></Link>
      </div>
    </section>
  );
};

export default CarBrandsSection;
